/* ============================================================
   Re-aplicador del cupon del club JDC
   ------------------------------------------------------------
   El codigo se guarda en localStorage al momento del canje (ver
   sections/jdc-club-v2.liquid). Aqui, en cualquier pagina, si el
   cliente tiene un codigo guardado y el carrito no lo trae, se
   aplica en silencio.

   NO pinta UI. La linea CLUB-XXXX(-$10.000) que ya muestra el
   drawer es la que comunica el resultado.

   Salvaguardas:
     · una sola vez por sesion, para no re-meterlo si el cliente
       lo quita a mano
     · maximo 20 intentos historicos
     · caduca a los 90 dias, la vigencia real del cupon
     · respeta cualquier otro codigo del club ya aplicado

   Diagnostico en consola:
     jdcRecode.estado()   ver que paso
     jdcRecode.ver()      ver el codigo guardado
     jdcRecode.correr()   forzar un intento
     jdcRecode.limpiar()  borrar el guardado
   ============================================================ */
(function () {
  if (window.jdcRecode) return;

  var LLAVE = 'jdc_club_code';
  var SES = 'jdc_club_code_sesion';
  var LOG = '[jdc-recode]';
  var MAX_INTENTOS = 20;
  var DIAS = 90;

  var est = { leido: null, motivo: 'sin correr', aplicado: false, aplicable: null };

  function log() {
    var a = [LOG].concat([].slice.call(arguments));
    console.log.apply(console, a);
  }
  function leer() {
    try { return JSON.parse(localStorage.getItem(LLAVE) || 'null'); } catch (e) { return null; }
  }
  function escribir(o) {
    try { localStorage.setItem(LLAVE, JSON.stringify(o)); } catch (e) {}
  }
  function borrar() {
    try { localStorage.removeItem(LLAVE); } catch (e) {}
  }

  function carrito() {
    return fetch('/cart.js?_=' + Date.now(), {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  function poner(codigo, previos) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: previos.concat([codigo]).join(',') })
    }).then(function (r) { return r.json(); });
  }

  function refrescarDrawer() {
    try {
      document.dispatchEvent(new CustomEvent('jdc:cart:updated'));
      if (window.T4SThemeSP && typeof window.T4SThemeSP.getCart === 'function') {
        window.T4SThemeSP.getCart();
      }
    } catch (e) {}
  }

  function correr(forzar) {
    var g = leer();
    est.leido = g;

    if (!g || !g.code) { est.motivo = 'sin codigo guardado'; return; }
    if (Date.now() - (g.ts || 0) > DIAS * 86400000) {
      est.motivo = 'codigo con mas de ' + DIAS + ' dias, borrado';
      borrar(); return;
    }
    if ((g.intentos || 0) >= MAX_INTENTOS) { est.motivo = 'limite de intentos alcanzado'; return; }
    if (!forzar) {
      try { if (sessionStorage.getItem(SES)) { est.motivo = 'ya se intento en esta sesion'; return; } } catch (e) {}
    }

    return carrito().then(function (c) {
      if (!c || !c.item_count) { est.motivo = 'carrito vacio, no hay nada que descontar'; return; }

      var previos = (c.discount_codes || []).map(function (d) { return d && d.code; }).filter(Boolean);
      var mismo = previos.some(function (x) { return String(x).toLowerCase() === g.code.toLowerCase(); });
      if (mismo) { est.motivo = 'ya estaba aplicado'; est.aplicado = true; return; }

      var otroClub = previos.some(function (x) { return /^(club-|ll-)/i.test(String(x)); });
      if (otroClub) { est.motivo = 'ya hay otro codigo del club, no lo toco'; return; }

      g.intentos = (g.intentos || 0) + 1;
      escribir(g);
      try { sessionStorage.setItem(SES, '1'); } catch (e) {}

      return poner(g.code, previos).then(function (out) {
        var dc = (out.discount_codes || []).filter(function (d) {
          return String(d && d.code).toLowerCase() === g.code.toLowerCase();
        })[0];
        est.aplicado = !!dc;
        est.aplicable = dc ? dc.applicable : null;
        est.motivo = dc ? ('aplicado, applicable=' + dc.applicable) : 'no quedo registrado';
        log(est.motivo, g.code, '| intento', g.intentos);
        if (dc && dc.applicable === true) refrescarDrawer();
      });
    }).catch(function (e) {
      est.motivo = 'error: ' + e;
      log('fallo', e);
    });
  }

  window.jdcRecode = {
    estado: function () { console.log(LOG, est); return est; },
    ver: leer,
    correr: function () { return correr(true); },
    limpiar: function () {
      borrar();
      try { sessionStorage.removeItem(SES); } catch (e) {}
      log('guardado y bandera de sesion borrados');
    }
  };

  if (document.readyState !== 'loading') correr(false);
  else document.addEventListener('DOMContentLoaded', function () { correr(false); });
})();
